type PropertyPackage = {
    price: number;
    properties: number;
}

export const featuredPropertyPackages: Record<number, PropertyPackage> = {
    1: {
        price: 15,
        properties: 1,
    },
    5: {
        price: 50,
        properties: 5,
    },
    10: {
        price: 77,
        properties: 10,
    },
    25: {
        price: 165,
        properties: 25,
    },
    50: {
        price: 275,
        properties: 50,
    },
    100: {
        price: 440,
        properties: 100,
    },
};

export const premiumPropertyPackages: Record<number, PropertyPackage> = {
    1: {
        price: 23,
        properties: 1,
    },
    5: {
        price: 75,
        properties: 5,
    },
    10: {
        price: 116,
        properties: 10,
    },
    25: {
        price: 248,
        properties: 25,
    },
    50: {
        price: 413,
        properties: 50,
    },
    100: {
        price: 660,
        properties: 100,
    },
};
